module.exports = __webpack_public_path__ + "bc07c2a4c6f3c242539c4eddb8f8c28d.woff";